export default __webpack_public_path__ + "static/media/armguards_of_the_vanguard.d781c04a.jpg";